import { render, staticRenderFns } from "./ProductNgList.vue?vue&type=template&id=1f1c395a&scoped=true&"
import script from "./ProductNgList.vue?vue&type=script&lang=js&"
export * from "./ProductNgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c395a",
  null
  
)

export default component.exports